import { Team } from 'modules/overlay-v2/domain/interfaces/game-info/state';

/**
 * Обнуляет матчевую статистику состава, оставляя сам состав и «сезонные» поля.
 *
 * Общий хелпер для сброса (`resetGameInfo`) и полного перебора хронологии
 * (`reparseEvents`): список полей `qty*Match` должен быть один — забытое поле
 * в одном из мест оставляло бы на табло счётчик от уже удалённого события.
 */
export function resetTeamStats(team: Team) {
  team.members = team.members?.map((member) => ({
    ...member,
    qtyFoulsMatch: 0,
    qtyGoalsMatch: 0,
    qtyRedCardsMatch: 0,
    qtyYellowCardsMatch: 0,
    qtyShootoutGoalsMatch: 0,
    qtyShootoutMissesMatch: 0,
  }));
  return team;
}
